import React from "react";
import { useParams } from "react-router";
import { useGetOneUserQuery } from "../../../services/user";
import UserProfile from "../UserProfile";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { HugeiconsIcon } from "@hugeicons/react";
import { Edit02Icon, LockPasswordIcon } from "@hugeicons/core-free-icons";
import { useTranslation } from "react-i18next";
import { BtnAsLink } from "../../../Component/BtnAsLink/BtnAsLink";
import { Space } from "antd";

export const DisplayUserProfile = () => {
  const { id } = useParams();
  const {
    data: userRes,
    isLoading,
    isFetching,
    isError,
  } = useGetOneUserQuery({ id });
  const { t } = useTranslation();

  const user = userRes?.data?.data;
  const loading = isLoading || isFetching;

  return (
    <>
      <PageHeader
        title={t("USER_PROFILE")}
        backTo={`/app/user_management/users`}
      >
        <Space>
          <BtnAsLink
            className="btn-secondary btn-outline"
            link={`/app/user_management/users/${id}/reset-password`}
            icon={<HugeiconsIcon size={20} icon={LockPasswordIcon} />}
          >
            {t("RESET_USER_PASSWORD")}
          </BtnAsLink>
          <BtnAsLink
            className="btn-primary"
            link={`/app/user_management/users/${id}/edit`}
            icon={<HugeiconsIcon size={18} icon={Edit02Icon} />}
          >
            {t("EDIT_USER_PROFILE")}
          </BtnAsLink>
        </Space>
      </PageHeader>

      <UserProfile
        {...{
          loading,
          isError,
          user,
          id,
        }}
      />
    </>
  );
};
